var $itemMenuCat;
var $itemLinksCat;
var $menuClientes;
var $btRollMenuCLI;
var categorias;
var conteudoAtual;
var $boxMenuCLI;
var TARGET_ATUAL;

var MENU_CLIENTES_ABERTO, MENU_CATEGORIAS_ABERTO;
var CONTENT_TIPO;
var TIPO_CLIENTE;
var TIPO_CATEGORIA;
var ALTURA_VIEW_CLI;
var ALTURA_ITENS_CLI;
var LIMITEY_ITENS;
var LABEL_TUDO;
var $JOBS, blocoJobs;

var SENTIDO_ROLAGEM;

var TIMEOUT;

var isTouchDevice;

$(document).ready(function () {
  if ($("#JOBS").length) {
    isTouchDevice = "ontouchstart" in document.documentElement;

    LABEL_TUDO = "tudo";

    $boxMenuCLI = $("#box-menu-clientes");
    $menuClientes = $("#menu-clientes");
    $itemMenuCLI = $(".item-clientes");
    $boxMenuCats = $("#box-menu-categorias");
    $menuCats = $("#menu-categorias");
    $labelCats = $("#label-selecionada");
    $itemMenuCat = $(".item-categorias");
    $itemLinksCat = $(".item-menu-categorias");
    $contentsCLI = $(".menu-clientes--itens-contents");
    $btRollMenuCLI = $(".menu-clientes--bt-roll");
    $JOBS = $("#JOBS");
    blocoJobs = ".bloco-jobs";

    // conteudoAtual = LABEL_TUDO;

    CONTENT_TIPO = null;
    TIPO_CLIENTE = "clientes";
    TIPO_CATEGORIA = "categorias";

    MENU_CLIENTES_ABERTO = false;
    MENU_CATEGORIAS_ABERTO = false;
    ALTURA_VIEW_CLI = 122;
    ALTURA_ITENS_CLI = $("#target-clientes").height() + 16;
    ALTURA_ITENS_CAT = $("#target-categorias").height() + 16;
    LIMITEY_ITENS = {
      clientes: -(ALTURA_ITENS_CLI - ALTURA_VIEW_CLI),
      categorias: -(ALTURA_ITENS_CAT - ALTURA_VIEW_CLI),
    };
    SENTIDO_ROLAGEM = 0;

    TIMEOUT = null;
    TARGET_ATUAL = null;

    $(document).click(function () {
      if ($boxMenuCLI.length) {
        $boxMenuCLI.removeClass("menu-aberto");
        $boxMenuCats.removeClass("menu-aberto");
      }
    });

    // hover das imagens
    $itemMenuCLI.hover(
      function () {
        $(this).addClass("item-ativo");
      },
      function () {
        if ($(this).text() != conteudoAtual) $(this).removeClass("item-ativo");
      }
    );

    $itemMenuCLI.click(function (e) {
      setGenericItemMenu(this, TIPO_CLIENTE);
    });

    $menuClientes.hover(
      function () {
        $(".item-menu-clientes.select-clientes").addClass("item-ativo");
      },
      function () {
        if (CONTENT_TIPO != TIPO_CLIENTE)
          $(".item-menu-clientes.select-clientes").removeClass("item-ativo");
      }
    );

    $menuClientes.click(function (e) {
      e.stopPropagation();
      MENU_CLIENTES_ABERTO = !MENU_CLIENTES_ABERTO;
      MENU_CATEGORIAS_ABERTO = false;

      if (MENU_CLIENTES_ABERTO) {
        TARGET_ATUAL = TIPO_CLIENTE;
        $boxMenuCLI.addClass("menu-aberto");
        $boxMenuCats.removeClass("menu-aberto");
      } else {
        $boxMenuCLI.removeClass("menu-aberto");
      }
    });

    $itemLinksCat.hover(
      function () {
        $(this).addClass("item-ativo");
      },
      function () {
        var nomeCat = $(this).text();
        nomeCat = nomeCat.trim();
        if (nomeCat != conteudoAtual) $(this).removeClass("item-ativo");
      }
    );

    $itemLinksCat.click(function (e) {
      MENU_CLIENTES_ABERTO = false;
      TARGET_ATUAL = TIPO_CATEGORIA;
      $boxMenuCLI.removeClass("menu-aberto");
      $boxMenuCats.removeClass("menu-aberto");

      setGenericItemMenu(this, TIPO_CATEGORIA);
    });

    $menuCats.hover(
      function () {
        $(".item-menu-clientes.select-categorias").addClass("item-ativo");
      },
      function () {
        if (CONTENT_TIPO != TIPO_CLIENTE)
          $(".item-menu-clientes.select-categorias").removeClass("item-ativo");
      }
    );

    $menuCats.click(function (e) {
      e.stopPropagation();
      MENU_CATEGORIAS_ABERTO = !MENU_CATEGORIAS_ABERTO;
      MENU_CLIENTES_ABERTO = false;

      if (MENU_CATEGORIAS_ABERTO) {
        TARGET_ATUAL = TIPO_CATEGORIA;
        $boxMenuCats.addClass("menu-aberto");
        $boxMenuCLI.removeClass("menu-aberto");
      } else {
        $boxMenuCats.removeClass("menu-aberto");
      }
    });

    $itemMenuCat.hover(
      function () {
        $(this).addClass("item-ativo");
      },
      function () {
        var nomeCat = $(this).text();
        nomeCat = nomeCat.trim();
        if (nomeCat != conteudoAtual) $(this).removeClass("item-ativo");
      }
    );

    $itemMenuCat.click(function () {
      setGenericItemMenu(this, TIPO_CATEGORIA);
    });

    $(".menu-clientes--bt-roll > a").click(function (e) {
      e.preventDefault();
    });

    $btRollMenuCLI.click(function (e) {
      e.stopPropagation();
    });

    $btRollMenuCLI.mousedown(function (e) {
      SENTIDO_ROLAGEM = $(this).data("s");
      TARGET_ATUAL = $(this).data("target");
      TIMEOUT = requestAnimationFrame(rolaMenuCliente);
    });

    $btRollMenuCLI.mouseup(function () {
      SENTIDO_ROLAGEM = 0;
      cancelAnimationFrame(TIMEOUT);
    });
    $btRollMenuCLI.mouseout(function () {
      SENTIDO_ROLAGEM = 0;
      cancelAnimationFrame(TIMEOUT);
    });

    // eventos de touch mobile ************************

    // $btRollMenuCLI.on("touchstart", function () {
    //   if (isTouchDevice) {
    //     SENTIDO_ROLAGEM = $(this).data("s");
    //     TIMEOUT = requestAnimationFrame(rolaMenuCliente);
    //   }
    // });

    // $btRollMenuCLI.on("touchend", function () {
    //   if (isTouchDevice) {
    //     SENTIDO_ROLAGEM = 0;
    //     cancelAnimationFrame(TIMEOUT);
    //   }
    // });

    $("#select-categorias").on("change", function () {
      if (this.value == "") return;
      console.log("selecionando CATEGORIAS");
      $("#select-clientes").val("");
      clickItemSelected(this.value);
    });
    $("#select-clientes").on("change", function () {
      if (this.value == "") return;
      console.log("selecionando CLIENTES");
      $("#select-categorias").val("");
      clickItemSelected(this.value);
    });
  }

  // inicializa os jobs
  filtraJobs(conteudoAtual);

  $(window).scroll(function () {
    mostraJobs();
  });
});

function clickItemSelected(filtro) {
  conteudoAtual = filtro;
  filtraJobs(conteudoAtual);
}

function mostraJobs() {
  if ($(blocoJobs).length) {
    $(blocoJobs).each(function () {
      if ($(this).css("opacity") == 0 && isInView($(this))) {
        $itImg = $("#bloco-proj-image-" + $(this).data("iditem"));
        $itVideo = $("#bloco-proj-video-" + $(this).data("iditem"));

        var src = $(this).data("img");

        if (TELA_MOBILE) {
          var dds = src.split("img_bg");
          src = dds[0] + "img_bg-mobile" + dds[1];
        }

        $itImg.css({ backgroundImage: "url(" + src + ")" });

        if ($(this).data("video") != "")
          $itVideo.attr("src", $(this).data("video"));

        $(this).addClass("bloco-show");
      }
    });
  }
}

function limpaItensMenu() {
  $itemLinksCat.each(function () {
    $(this).removeClass("item-ativo");
  });
  $itemMenuCat.each(function () {
    $(this).removeClass("item-ativo");
  });
  $itemMenuCLI.each(function () {
    $(this).removeClass("item-ativo");
  });
}

function setGenericItemMenu(el, tipo) {
  limpaItensMenu();

  var nomeCat = $(el).text();
  nomeCat = nomeCat.trim();

  if (nomeCat != conteudoAtual) {
    $(el).addClass("item-ativo");
    conteudoAtual = nomeCat;
  } else {
    $("#item-tudo").addClass("item-ativo");
    conteudoAtual = LABEL_TUDO;
    tipo = TIPO_CATEGORIA;
  }

  MENU_CATEGORIAS_ABERTO = false;
  MENU_CLIENTES_ABERTO = false;
  $boxMenuCats.removeClass("menu-aberto");
  $boxMenuCLI.removeClass("menu-aberto");

  CONTENT_TIPO = tipo;

  $labelCats.empty();

  if (tipo == TIPO_CATEGORIA) {
    $(".item-menu-clientes.select-clientes").removeClass("item-ativo");
    $(".item-menu-clientes.select-categorias").addClass("item-ativo");
    $labelCats.append(conteudoAtual);
  } else {
    $(".item-menu-clientes.select-clientes").addClass("item-ativo");
    $(".item-menu-clientes.select-categorias").removeClass("item-ativo");
    $labelCats.append(LABEL_TUDO);
  }

  filtraJobs(conteudoAtual);
}

function rolaMenuCliente() {
  if (SENTIDO_ROLAGEM == 0 || !TARGET_ATUAL) return;

  var posy = parseInt(
    $("#target-" + TARGET_ATUAL)
      .css("margin-top")
      .replace("px", "")
  );

  if (SENTIDO_ROLAGEM < 0 && posy <= LIMITEY_ITENS[TARGET_ATUAL]) return;
  if (SENTIDO_ROLAGEM > 0 && posy >= 0) return;

  var vel = 2;

  posy += vel * SENTIDO_ROLAGEM;

  if (SENTIDO_ROLAGEM < 0 && posy <= LIMITEY_ITENS[TARGET_ATUAL])
    posy = LIMITEY_ITENS[TARGET_ATUAL];
  if (SENTIDO_ROLAGEM > 0 && posy >= 0) posy = 0;

  $("#target-" + TARGET_ATUAL).css("margin-top", posy + "px");

  TIMEOUT = requestAnimationFrame(rolaMenuCliente);
}

function filtraJobs(f) {
  if (typeof __j__ === "undefined") return;

  f = f || LABEL_TUDO;

  var result = __j__.slice(0);

  if (f != LABEL_TUDO) {
    result = [];

    for (var i = 0; i < __j__.length; i++) {
      var item = __j__[i];
      if (item.filtros.indexOf(f) >= 0) result.push(item);
    }
  }

  renderJobs(result);
}

function renderJobs(arr) {
  $JOBS.empty();

  var saida = "";
  var path = __BASEHTML__ + "uploads/projetos/";

  for (var i = 0; i < arr.length; i++) {
    var it = arr[i];
    var itImg = path + it.img;
    var itVideo = it.video == "" ? "" : path + it.video;

    saida += '<a href="' + __BASESITE__ + "/portfolio/" + it.slug + '" >';
    saida +=
      '<div class="geral--projetos-container bloco-jobs nomargin" data-iditem="' +
      it.id +
      '" data-img="' +
      itImg +
      '" data-video="' +
      itVideo +
      '">';
    saida +=
      '<div id="bloco-proj-' +
      it.id +
      '" class="container-bloco-100" onmouseover="ovrBlcProj(' +
      it.id +
      ",'" +
      it.titulo +
      "');ovrBlcVideo(" +
      it.id +
      ', 1);"  onmouseout="ovrBlcProj(' +
      it.id +
      ");ovrBlcVideo(" +
      it.id +
      ');">';

    if (it.video != "") {
      saida +=
        '<video id="bloco-proj-video-' +
        it.id +
        '" loop muted autoplay class="video--mouseover content-media-swap content--hidden"><source src="" type="video/mp4" /></video>';
    }

    saida +=
      '<div id="bloco-proj-image-' +
      it.id +
      '" class="bloco-img-zoom" style="background: url() center center / cover no-repeat;"></div>';
    saida += '<div class="bloco-img-zoom--conteudo-interno Grid">';
    saida +=
      '<div class="conteudo-interno--logo"> <img src="' +
      __BASEHTML__ +
      "uploads/clientes/" +
      it.logo +
      '" alt=""> </div>';
    saida += '<div class="conteudo-interno--titulo">' + it.titulo + "</div>";
    saida +=
      '<div id="barra-tit-proj-' +
      it.id +
      '" class="conteudo-interno--barra"></div>';
    saida += "</div></div></div></a>";
  }

  $JOBS.append(saida);

  mostraJobs();
}
